import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 59CEB0A5-75F5-4D3D-AF4D-2F0D8AEAEB0C
 * name pan-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-left.svg
 * tags
 */
export const PanLeftIcon = createSvgIcon(<><path d="M7,8L2.5,12L7,16V8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z" /></>, 'PanLeftIcon');
export default PanLeftIcon